import React from 'react';
import Octicon from 'react-octicon';
import send from '../utils';
import './header.css';

export default () => (
  <div className="app-header sticky-top">
    <a href="#sectionTwo"  data-anchor="sectionTwo">
      立即收聽
    </a>
    <a onClick={() => send('Button', 'Click', 'Btn_search')} href="https://www.google.com.tw/search?q=%E6%AD%A2%E7%97%9B%E8%97%A5+%E6%AE%98%E7%95%99&oq=%E6%AD%A2%E7%97%9B%E8%97%A5+%E6%AE%98%E7%95%99&aqs=chrome..69i57.12264j0j2&sourceid=chrome&ie=UTF-8" target="_blank" rel="noopener noreferrer">
      <div>
        <Octicon className="search" name="search" />
        止痛藥殘留體內?
      </div>
    </a>
  </div>
);



// WEBPACK FOOTER //
// ./src/Header/index.js